import React from "react";
import {Row, Col, Input} from "antd";
import Card from "./card";
import List from "./list";

const Main : React.FC = () => {
    return (
        <div className={"public-container"}>
            <div className={"main-list global"}>
                <Row gutter={[20, 20]}>
                    <Col lg={{push : 17, span : 7}} md={{push : 17, span : 7}} sm={24} xs={24}>
                        <Input.Search
                            enterButton={true}
                            size={"large"}
                            width={"100%"}
                            placeholder={"Cari Artikel..."}
                            style={{marginBottom : 20}}
                        />
                    </Col>
                    <Col lg={{pull : 7, span : 17}}  md={{pull : 7, span : 17}} sm={24} xs={24}/>
                    <Col lg={{push : 17, span : 7}} md={{push : 17, span : 7}} sm={24} xs={24}>
                        <List />
                    </Col>
                    <Col lg={{pull : 7, span : 17}}  md={{pull : 7, span : 17}} sm={24} xs={24}>
                        <Card />
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default React.memo(Main);